import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AsideService } from './aside.service';
import { DialogService } from 'primeng/dynamicdialog';
import { WidgetService } from 'src/app/components/widget/widget.service';


@Component({
    selector: 'app-aside',
    standalone: false,
    templateUrl: './aside.component.html',
    styleUrls: ['./aside.component.scss']
})
export class AsideComponent implements OnInit, OnDestroy {

    isCollapsed:boolean = false;
    groups: any = [];
    private menuChanged?: Subscription;
    private menuInitSubscription?: Subscription;
    isDash: boolean = false;

    constructor(private readonly asideService: AsideService,
                private readonly dialogService: DialogService,
                protected readonly widgetService: WidgetService
    ) { }

    ngOnInit(): void {
        this.menuChanged = this.asideService.menuChanged$.subscribe(menuData => {
            this.isDash = menuData.name === 'home';
        });

        this.menuInitSubscription = this.asideService.menuInit$.subscribe(() => {
            if (this.isCollapsed) {
                this.isCollapsed = false;
            }
        });
    }

    ngOnDestroy(): void {
        this.menuChanged?.unsubscribe();
        this.menuInitSubscription?.unsubscribe();
    }

    toggleField() {
        if(this.dialogService.dialogComponentRefMap.size === 0){
            this.isCollapsed = !this.isCollapsed;
        }      
    }
}
